import _ from 'underscore'
import { popShow } from '../../../manager/mall.event'
import { payModel } from '../pay.model'
import Logger from 'Logger'
import { LINK, setPokerClass } from '../../../config'
import {
  $number,
  runGameOrGoScene,
  refresh,
  pokerClassName,
  mallClose,
  eventBus,
} from '../../../utils'
import store from '../../../store'
import { popupModel } from '../../popup/popup.model'
import { GOODS_ID } from '../../../config'
import { LADDER_GAME, LUCKY_CARD } from '../../gacha/gacha-game'

/**
 * @param {Object} data - ajax result
 */
export function purchaseItemInfoPop(data) {
  try {
    Logger.info('%c [PAYMENT_RESULT]', 'color:rosybrown;font-size:2em;', {
      data,
    })

    if (!data && !data.resultCode === 0 && !data.resultCode) {
      throw new Error('NOT_EXIST_RESULT_CODE || RESPONSE ERROR')
    }

    var resultCode = data.resultCode
    var payCategory = data.payCategory // gift | auto | goods

    switch (resultCode) {
      case 0:
        showPaymentFailed(data)
        break

      // 구매 완료
      case 1:
        Logger.info('payCategory', payCategory)
        if (payCategory === 'auto') {
          showAutoSuccess(data)
        } else if (payCategory === 'gift') {
          showGiftSuccess(data)
        } else {
          showPaySuccess(data) // payCategory === goods
        }
        break

      // 구매 가능 금액 초과
      case -1:
        popShow({
          template: 'receipt',
          title: '구매 실패',
          message: '구매 가능 금액이 초과되어 구매할 수 없습니다. ',
          onClose: function () {
            showMoneyLimitInfo(data, cleanUp)
          },
        })
        break

      // 구매 한도 초과
      case -2:
        popShow({
          template: 'receipt',
          title: '구매 실패',
          message:
            '구매 한도가 초과되어 구매할 수 없습니다. <br /> (잔여 한도 : ' +
            $number(store.list.get('purchaseLimit')).comma() +
            '원 남음)',
          onClose: function () {
            showMoneyLimitInfo(data, cleanUp)
          },
        })
        break

      case -13:
        popShow({
          title: '선물하기 불가',
          message: '선물하기를 할 수 없는 회원입니다.<br /> (클래스 보유 회원)',
          onClose: function () {
            showMoneyLimitInfo(data, cleanUp)
          },
        })
        break
    }
  } catch (error) {
    // 구매 성공시 41 줄에서 결과 팝업을 표시하고, 그 안의 parseItems() 실행하면서 오류가 나고 여기로 옴
    Logger.info('purchaseItemInfoPop:', resultCode, data, error)

    // 대부분의 구매 성공이 이 로직을 타게 됨
    /// var 호이스팅으로 resultCode를 확인하는... 언제부터 이렇게 하고 있었지...
    if (resultCode === 1) {
      const goodsId =
        data && data.pmang_cash_purchase
          ? data.pmang_cash_purchase.success_goods_list[0].goods_id // 피망캐쉬로 구매한 상품의 첫번째
          : '(none)'

      // 아이템함 바로가기 버튼 숨김 : 기본 표시, 일부 상품만 숨김
      const hideItemBox = GOODS_ID.HIDE_ITEM_BOX.includes(goodsId)

      // 선물함 바로가기 표시, 24년 3월에 이모티콘 뽑기 추가하면서 생김
      const mustGoGiftBox = GOODS_ID.GIFT_BOX.includes(goodsId)

      let message = ''
      let confirmText = ''

      if (hideItemBox) {
        message = '구매가 완료되었습니다.'
        confirmText = ''
      } else if (mustGoGiftBox) {
        message = '구매가 완료되었습니다.<br />선물함에서 확인하세요.'
        confirmText = '선물함 가기'
      } else {
        message =
          '구매가 완료되었습니다.<br />아이템은 아이템함에서 사용 설정하세요.'
        confirmText = '아이템함 가기'
      }

      popShow({
        title: '구매 완료',
        message: message,
        confirmText: confirmText,
        confirmBtnColor: '',
        closeBtnColor: hideItemBox || mustGoGiftBox ? '' : 'gray', // 닫기 버튼 색상
        closeText: '확인',
        onClose: function () {
          showMoneyLimitInfo(data, cleanUp)
          // 확인 버튼 클릭시 아이템별로 추가 동작이 필요할 때 사용
          beforeCloseHook(goodsId, cleanUp)
        },
        onConfirm: function () {
          showMoneyLimitInfo(data, () => {
            // 모바일에선 씬 이동, PC에선 게임 실행
            runGameOrGoScene(mustGoGiftBox ? 'MyBagGift' : 'MyBagItem')
          })
        },
      })
    } else {
      showPaymentFailed(data) // 실패 팝업
    }
  }
}

/**
 * 닫기 버튼 눌렀을때 api 재요청 및 닫기
 */
function cleanUp() {
  popupModel.hide()
  payModel.hide()
  store.list.fetch({ reload: true })
  refresh()
  mallClose()
}

function parseItems(purchaseData) {
  var hasfailGoods = purchaseData.is_compensation || false
  var successItems = payModel.calcResponseGoods(
    purchaseData.success_goods_list || []
  )
  var failItems = payModel.calcResponseGoods(purchaseData.fail_goods_list || [])

  return {
    hasfailGoods: hasfailGoods,
    successItems: successItems,
    failItems: failItems,
  }
}

/** 구매 성공 팝업 : payCategory가 goods */
function showPaySuccess(data) {
  var parsedItem = parseItems(data.pmang_cash_purchase || null)
  var successItems = parsedItem.successItems
  var hasfailGoods = parsedItem.hasfailGoods
  var failItems = parsedItem.failItems

  if (!hasfailGoods) {
    // 정상 구매 완료
    popShow({
      template: 'receipt',
      title: '구매 완료',
      message:
        '구매가 완료되었습니다.<br />아이템은 아이템함에서 사용 설정하세요.',
      successGoodsName: successItems.goodsName,
      confirmText: '아이템함 가기',
      confirmBtnColor: '',
      closeBtnColor: 'gray',
      closeText: '확인',
      onClose: function () {
        showMoneyLimitInfo(data, cleanUp)
        // 확인 버튼 클릭시 아이템별로 추가 동작이 필요할 때 사용
        beforeCloseHook(successItems.goodsId, cleanUp)
      },
      onConfirm: function () {
        showMoneyLimitInfo(data, runGameOrGoScene)
      },
    })
  } else {
    // 미지급 상품이 있을 경우, 효력지급이 되지 않고 피망캐쉬로 적고
    popShow({
      template: 'receipt',
      title: '미지급 상품',
      message: '미지급된 상품은 <br /> 피망캐쉬로 적립되었습니다.',
      successGoodsName:
        successItems.goodsName +
        '<br /> 피망캐쉬 ' +
        $number(failItems.totalPrice).comma() +
        '원 적립',
      confirmText: '도움말',
      closeBtnColor: 'gray',
      closeText: '확인',
      onClose: function () {
        showMoneyLimitInfo(data, cleanUp)
      },
      onConfirm: function () {
        showMoneyLimitInfo(data, function () {
          window.open(LINK.HELP, '_blank')
        })
      },
    })
  }
}

function showGiftSuccess(data) {
  var id =
    data.target_pplus_member_info.nickname ||
    data.target_pplus_member_info.member_id ||
    data.target_pplus_member_info.account_info ||
    '회원' // 결과에 닉네임, GSN, 아이디 정보 순으로 표시

  var parsedItem = parseItems(data.pmang_cash_purchase || null)
  var successItems = parsedItem.successItems
  var hasfailGoods = parsedItem.hasfailGoods
  var failItems = parsedItem.failItems

  if (!hasfailGoods) {
    // 정상구매
    popShow({
      template: 'receipt',
      title: '선물하기 완료',
      message: id + '님께 <br />선물하기가 완료되었습니다.',
      successGoodsName: successItems.goodsName,
      closeText: '확인',
      onClose: function () {
        showMoneyLimitInfo(data, cleanUp)
      },
    })
  } else {
    // 미지급 상품이 있을경우
    popShow({
      template: 'receipt',
      title: '미지급 선물',
      message: '미지급된 선물은 <br /> 피망캐쉬로 적립되었습니다.',
      successGoodsName:
        successItems.goodsName +
        '<br /> 피망캐쉬 ' +
        $number(failItems.totalPrice).comma() +
        '원 적립',
      confirmText: '도움말',
      closeBtnColor: 'gray',
      closeText: '확인',
      onClose: function () {
        showMoneyLimitInfo(data, cleanUp)
      },
      onConfirm: function () {
        showMoneyLimitInfo(data, function () {
          window.open(LINK.HELP, '_blank')
        })
      },
    })
  }
}

/**
 * 정기결제 상품 정상 구매 / 혹 미지급 상품 있을 경우 팝업
 */
function showAutoSuccess(data) {
  var autoData = data.pmang_autopayment_purchase || null
  var itemName = pokerClassName(autoData.class_name)

  setPokerClass(autoData.class_name)
  popShow({
    template: 'receipt',
    title: '정기결제 완료',
    message:
      itemName +
      ' 정기결제가 신청되었습니다. <br /> ' +
      '전용 게임 머니 및 아이템은<br />' +
      '게임 내 아이템함에서 받을 수 있습니다.',
    successGoodsName: itemName,
    confirmText: '아이템함 가기',
    confirmBtnColor: '',
    closeBtnColor: 'gray',
    closeText: '확인',
    onClose: function () {
      showMoneyLimitInfo(data, cleanUp)
    },
    onConfirm: function () {
      showMoneyLimitInfo(data, runGameOrGoScene)
    },
  })
}

function showPaymentFailed(data) {
  popShow({
    title: '구매 실패',
    message:
      '구매에 실패했습니다. <br />결제에 어려움이 있다면 도움말을 확인하세요.',
    confirmText: '도움말',
    onClose: function () {
      showMoneyLimitInfo(data, cleanUp)
    },
    onConfirm: function () {
      showMoneyLimitInfo(data, function () {
        window.open(LINK.HELP, '_blank')
      })
    },
  })
}

/**
 * 클래스머니 한도 초과 안내 메세지 팝업  compensation_info 가 존재 할때 보여준다.
 * https://jira.neowiz.com/browse/WEBTECH-804?focusedCommentId=307081&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-307081
 * @param {*} data - ajax는 result
 */
function showMoneyLimitInfo(data, callback) {
  //compensation_info 클래스 한초과 안내 데이터
  var reward = data.compensation_info

  function hasCompernsationInfo(info) {
    return info && info.receive_money + info.gift_money > 0
  }

  if (!hasCompernsationInfo(reward)) {
    return _.isFunction(callback) && callback(data)
  }

  var classMoney = reward.receive_money + reward.gift_money - reward.eff_value
  var dailyMoney = reward.eff_value

  popupModel.hide()

  popShow({
    template: 'moneyLimitInfo',
    title: '클래스 전용 머니 / 데일리 머니',
    message:
      ' 수령하지 않은 <b>클래스 전용머니, 데일리 머니</b>가<br />선물함에 합산 되었습니다.',
    classMoney: classMoney && $number(classMoney).text({ tag: true }),
    dailyMoney: dailyMoney && $number(dailyMoney).text({ tag: true }),
    onClose: function () {
      this.hide()
      _.isFunction(callback) && callback(data)
    },
  })
}

/**
 * @param {string} goodsId
 * @param {() => void} handleClose
 */
function beforeCloseHook(goodsId, handleClose) {
  Logger.info('beforeCloseHook: goodsId =', goodsId)

  // 행운 뽑기 아이템일 경우 구매 후 확인 클릭시 뽑기 게임 표시
  if (GOODS_ID.LUCKY_DRAW.includes(goodsId)) {
    Logger.info('Open LuckyCard')
    eventBus.trigger('GachaView:open', { gachaName: LUCKY_CARD })
  }

  if (GOODS_ID.LADDER_GAME.includes(goodsId)) {
    Logger.info('Open LadderGame')
    eventBus.trigger('GachaView:open', { gachaName: LADDER_GAME })
  }

  // goodsId 별로 확인 클릭시 실행하고 싶은 동작 추가

  if (typeof handleClose === 'function') {
    handleClose()
  }
}
